import React from 'react'
import { ScrollArea } from '@/common/ui/scroll-area'
import { cn } from '@/common/utils'

export interface PageContainerProps {
	children: React.ReactNode
	scrollable?: boolean
	className?: string
}

export default function PageContainer({
	children,
	scrollable = true,
	className,
}: PageContainerProps) {
	return (
		<>
			{scrollable ? (
				<ScrollArea>
					<div className={cn('h-full p-4 md:px-8', className)}>{children}</div>
				</ScrollArea>
			) : (
				<div className={cn('h-full p-4 md:px-8', className)}>{children}</div>
			)}
		</>
	)
}
